var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdcardMonochrome = function SvgIdcardMonochrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 22,
    className: "idcard-monochrome_svg__wrapper"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.337 6.9V3.96c0-.35-.28-.63-.63-.63h-3.6c-.35 0-.63.28-.63.63v4.89z",
    className: "idcard-monochrome_svg__secondary-path"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.287.08h23.76c1.57 0 2.84 1.22 2.84 2.73v16.38c0 1.5-1.27 2.73-2.84 2.73H3.287c-1.57 0-2.84-1.22-2.84-2.73V2.81c0-1.5 1.27-2.73 2.84-2.73m23.76 21.03c1.12 0 2.03-.86 2.03-1.92V2.81c0-1.06-.91-1.92-2.03-1.92H3.287c-1.12 0-2.03.86-2.03 1.92v16.38c0 1.06.91 1.92 2.03 1.92zm-7.68-17.79h-7.64c-.35 0-.63.28-.63.63v14.08c0 .35.28.63.63.63h7.2c7.16 0 7.73-5.62 7.73-7.17V10.3c-.25-6.15-5.26-6.99-7.29-6.99zm-1.15 11.16h-2.26V7.54h2.35s3.3-.25 3.3 3.38-3.39 3.56-3.39 3.56m-13.74 3.56c0 .35.28.63.63.63h3.6c.35 0 .63-.28.63-.63V8.68l-4.86 1.95z",
    className: "idcard-monochrome_svg__primary-path",
    clipRule: "evenodd"
  })));
};
export default SvgIdcardMonochrome;